// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main {
  background-color: #191818 !important;
  color: white !important;
  width: 14.15vw !important;
  /* height: 231px !important; */
  position: fixed !important;
  top: 3.55vw !important;
  right: 0 !important;
  outline: none !important;
}

.main-box {
  border-bottom: 2px solid #0d0d0d !important;
  height: 8.3vw !important;
  padding: 1vw .75vw !important;
}

.main-title {
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  font-size: 0.9vw !important;
  line-height: 1.35vw !important;
}

/*card */
.Card-Content {
  width: fit-content !important;
  margin-top: 1vw !important;
  cursor: pointer !important;
}

.Card-logo {
  padding: 0.65vw 0.75vw !important;
  background-color: #0c0c0c !important;
  width: 2.5vw !important;
  height: 2.5vw !important;
  border-radius: 0.4vw !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.Card-title {
  width: 1.75vw !important;
  height: 1.3vw !important;
  text-align: center !important;
  font-size: 0.5vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  line-height: 0.65vw !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-top: 0.25vw !important;
}

/* right side bar footer css */
.footer-modal {
  border-top: 2px solid #0d0d0d !important;
  height: 3.45vw !important;
  padding: 0.8vw 0.75vw 1vw !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/modals/rightSideBarStyle.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,2CAA2C;EAC3C,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,QAAQ;AACR;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,uBAAuB;EACvB,wBAAwB;EACxB,+BAA+B;EAC/B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;AACtC","sourcesContent":[".main {\n  background-color: #191818 !important;\n  color: white !important;\n  width: 14.15vw !important;\n  /* height: 231px !important; */\n  position: fixed !important;\n  top: 3.55vw !important;\n  right: 0 !important;\n  outline: none !important;\n}\n\n.main-box {\n  border-bottom: 2px solid #0d0d0d !important;\n  height: 8.3vw !important;\n  padding: 1vw .75vw !important;\n}\n\n.main-title {\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  font-size: 0.9vw !important;\n  line-height: 1.35vw !important;\n}\n\n/*card */\n.Card-Content {\n  width: fit-content !important;\n  margin-top: 1vw !important;\n  cursor: pointer !important;\n}\n\n.Card-logo {\n  padding: 0.65vw 0.75vw !important;\n  background-color: #0c0c0c !important;\n  width: 2.5vw !important;\n  height: 2.5vw !important;\n  border-radius: 0.4vw !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n\n.Card-title {\n  width: 1.75vw !important;\n  height: 1.3vw !important;\n  text-align: center !important;\n  font-size: 0.5vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  line-height: 0.65vw !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n  padding-top: 0.25vw !important;\n}\n\n/* right side bar footer css */\n.footer-modal {\n  border-top: 2px solid #0d0d0d !important;\n  height: 3.45vw !important;\n  padding: 0.8vw 0.75vw 1vw !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
